<template>
  <v-col cols="12" sm="6" lg="3">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="text-h6 font-weight-bold"> Matrículas Ativas </v-card-text>

      <v-row>
        <v-col>
          <v-card-text class="text-h4 font-weight-bold">
            {{ qtd ?? 0 }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    franquiaId: {
      type: Number,
    },
  },
  name: "MatriculasAtivasCard",
  mounted() {
    this.getQtd(this.franquiaId);
  },
  watch: {
    franquiaId(value) {
      this.getQtd(value);
    },
  },
  data() {
    return {
      loading: true,
      qtd: 0,
    };
  },
  methods: {
    async getQtd(franquiaId) {
      if (!franquiaId) return;

      this.loading = true;
      try {
        this.qtd = await this.$services.matriculasService.qtdAtivas(franquiaId);
      } catch (error) {
        this.$handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
